import { Component, OnInit } from '@angular/core';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { ReviewOrderModalComponent } from '../review-order-modal/review-order-modal.component';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'kx-review-order',
    templateUrl: './review-order.component.html',
    styleUrls: ['./review-order.component.scss'],
    standalone: false
})
export class ReviewOrderComponent implements OnInit {
  bannerJson: {};
  data: any;
  keys: string[];

  constructor(
    private modal: SmartModalService,
    private baseService: BaseService,
    private Aroute: ActivatedRoute,
    private route: Router
  ) { }

  ngOnInit() {
    this.setBanner();
    this.getData();
  }

  setBanner() {
    this.bannerJson = {
      "selector": "app-patient-layout",
      "datasource": {
        "application": "appointment",
        "resource": "appointment",
        "query_id": "GET_BY_ID"
      }
    }
  }

  getData() {
    this.data = JSON.parse(localStorage.currentData);
    this.keys = Object.keys(this.data);
  }

  getPaymentDetail() {
    this.getPaymentDetail$().subscribe((result) => {
      if (result.count == 1) {
        this.hasPopupOpen(result) //change here 
      } else {
        this.hasPopupOpen(result)
      }
    })

  }

  getPaymentDetail$(): Observable<any> {
    return this.baseService.get("GET_GATEWAY_DETAILS", "dummy:dummy", "payment_gateway_details", "payment-gateway")
  }

  hasPopupOpen(res: any) {
    var hasApiResponse = {};
    hasApiResponse['ApiResponse'] = res;
    hasApiResponse["hasData"] = this.data;

    this.modal.open(ReviewOrderModalComponent, hasApiResponse, "Payment Method", ModalSize.Sm).subscribe((result) => {
      console.log("result", result);
    },
      (err) => {
        console.error("error in getting data :: ", err);
      }
    )
  }

  hasGatewayResponse$(): Observable<any> {
    var args = "uhId:" + this.data.uhId + "orderId:" + this.data.orderId + "amount:" + this.data.price + "id:" + this.data.id
    return this.baseService.get("PROCCED_PAYMENT", args, "ui_gateway_response", "payment-gateway");
  }

  previous() {
    this.Aroute.queryParams.subscribe((hasUrlData) => {
      this.route.navigate([hasUrlData.returnUrl])
    })
  }

}
